module.exports = __webpack_public_path__ + "Kevin Lee-5546df06.png";